import { enableProdMode, Injectable, ErrorHandler, Injector, Inject, InjectionToken, LOCALE_ID, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { GlobalErrorHandler, RollbarService, rollbarFactory } from './app/app.module';
import { environment } from './environments/environment';
import { AuthService } from './app/shared/auth/auth.service';
import { Router } from '@angular/router';
import { AuthGuard } from './app/shared/auth/auth-guard.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthTokenInterceptor } from './app/shared/auth/auth-token-interceptor';
import { NgbDateAdapter, NgbDateNativeUTCAdapter, NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateITParserFormatter } from './app/NgbDateITParserFormatter';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app/app-routing.module';
import { ToastrModule } from 'ngx-toastr';
import { Angulartics2Module } from 'angulartics2';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';



if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            AppRoutingModule,
            NgbModule,
            ToastrModule.forRoot({
                timeOut: 5000,
                extendedTimeOut: 2000,
                closeButton: true,
                progressBar: true,
                positionClass: 'toast-top-right',
                preventDuplicates: true,
            }),
            Angulartics2Module.forRoot()
        ),
        AuthService,
        { provide: RollbarService, useFactory: rollbarFactory },
        AuthGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthTokenInterceptor,
            multi: true
        },
        {
            provide: LOCALE_ID,
            useValue: 'it-IT'
        },
        {
            provide: NgbDateAdapter,
            useClass: NgbDateNativeUTCAdapter
        },
        {
            provide: NgbDateParserFormatter,
            useClass: NgbDateITParserFormatter
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations()
    ]
});
